// Re-export placeholder for attendance store - to be implemented later
export const AttendanceStore = null;
export type AttendanceStoreType = any;
